<template>
  <div class="list-main">
    <div class="main-header">
      <div class="head-title">我的档案</div>
      <div class="head-line"></div>
      <div class="head-modal">
        <span class="label">考试名称</span>
        <input
          v-model="listQuery.examGradeUserSearchBase.examName"
          style="margin-right: 60px"
          type="text"
          @keyup.enter="requestList"
        />
        <div class="search-btn" @click="requestList">查询</div>
      </div>
    </div>
    <div class="main-content">
      <el-table
        empty-text="暂无数据"
        class="customer-table"
        :data="tableData"
        stripe
        style="width: 989px"
      >
        <el-table-column header-align="center" label="考试名称" width="300">
          <template slot-scope="scope">
            <span style="padding-left: 32px" class="exam-name">{{
              scope.row.examName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="考试类型">
          <template slot-scope="scope">
            <span>{{ scope.row.examTypeCodeName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="examTime" label="成绩">
          <template slot-scope="scope">
            <span>{{ scope.row.gradeScoreValue }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="examTime" label="是否通过">
          <template slot-scope="scope">
            <span
              style="
                font-size: 14px;
                font-weight: 400;
                text-align: left;
                color: rgb(255, 0, 0);
                line-height: 15px;
              "
              >{{ scope.row.isPassValue }}</span
            >
          </template>
        </el-table-column>
        <el-table-column align="center" prop="examTime" label="状态">
          <template slot-scope="scope">
            <span
              style="
                font-size: 14px;
                font-weight: 400;
                text-align: left;
                line-height: 15px;
              "
            >
              {{ scope.row.gradeStatusCodeName }}</span
            >
          </template>
        </el-table-column>
        <!-- <el-table-column
          align="center"
          prop="lastUpdateTimeValue"
          label="最后提交时间"
        >
          <template slot-scope="scope">
            <span
              style="
                font-size: 14px;
                font-weight: 400;
                text-align: left;
                line-height: 15px;
              "
            >
              {{ scope.row.lastUpdateTimeValue }}</span
            >
          </template>
        </el-table-column> -->
        <el-table-column align="center" prop="address" label="操作">
          <template slot-scope="scope">
            <div
              class="handle-btn"
              v-if="
                scope.row.isAllowSeePaper &&
                scope.row.gradeStatusCodeName != '考试中'
              "
              @click="goAnswerPaper(scope.row)"
            >
              查看答卷
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div
        style="
          position: absolute;
          bottom: 0;
          height: 30px;
          margin: 36px auto;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
        "
      >
        <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          background
          layout="total,  prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav.vue";
import Api from "@/api/examList";
export default {
  components: { Nav },
  data() {
    return {
      total: 0,
      page: 1,
      pageSize: 8,
      tableData: [],
      listQuery: {
        SkipCount: 0,
        MaxResultCount: 8,
        examGradeUserSearchBase: {
          examClassCode: "exam",
          examName: "",
        },
      },
      activeType: "make",
    };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    jscomNewOpenMaxWindow(url, target) {
      let tt, w, left, top, width, height;
      width = screen.width;
      height = screen.height - 60;
      left = 0;
      if (left < 0) {
        left = 0;
      }

      top = 0;
      if (top < 0) {
        top = 0;
      }

      tt =
        "toolbar=no, menubar=no, scrollbars=yes,resizable=no,location=no, status=yes,fullscreen=yes,";
      tt =
        tt +
        "width=" +
        width +
        ",height=" +
        height +
        ",left=" +
        left +
        ",top=" +
        top;
      w = window.open(url, target, tt);
      try {
        w.focus();
        return w;
      } catch (e) {}
    },
    goAnswerPaper(item) {
      if (item.isAllowSeePaper && item.gradeStatusCodeName != "考试中") {
        let routeData = this.$router.resolve({
          path: "/exam/paper/detail",
          query: { examUid: item.examUid, examGradeUid: item.examGradeUid },
        });
        this.jscomNewOpenMaxWindow(routeData.href, "_blank");
        // this.$router.replace(`/exam/paper/detail?examUid=${item.examUid}&examGradeUid=${item.examGradeUid}`);
      }
    },
    searchList() {
      switch (this.activeType) {
        case "make":
          this.makeExam("make");
          break;
        case "makeUp":
          this.makeExam("makeUp");
          break;
        case "noSubmit":
          break;
      }
    },
    makeExam(type) {
      this.activeType = type;
      if (type == "makeUp") {
        this.listQuery.examGradeUserSearchBase.isExamination = true;
      } else {
        this.listQuery.examGradeUserSearchBase.isExamination = false;
      }
      this.requestList();
      this.$forceUpdate();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.requestList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.requestList();
    },
    requestList() {
      if (this.pageSize) {
        this.listQuery.MaxResultCount = this.pageSize;
      }
      this.listQuery.SkipCount =
        (this.page - 1) * this.listQuery.MaxResultCount;
      Api.getRecordList(this.listQuery)
        .then((res) => {
          this.tableData = res.data.items;
          this.total = res.data.totalCount;
          this.tableData.forEach((item) => {
            if (item.beginTimeFormat) {
              item.beginTimeFormat =
                item.beginTimeFormat.split(" ")[0] +
                " " +
                item.beginTimeFormat.split(" ")[1].split(":")[0] +
                ":" +
                item.beginTimeFormat.split(" ")[1].split(":")[1];
            }
            if (item.endTimeFormat) {
              item.endTimeFormat =
                item.endTimeFormat.split(" ")[0] +
                " " +
                item.endTimeFormat.split(" ")[1].split(":")[0] +
                ":" +
                item.endTimeFormat.split(" ")[1].split(":")[1];
            }
          });
        })
        .catch((err) => {
          console.warn(err);
        });
    },
  },
  created() {
    this.requestList();
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-input__inner {
  height: 100%;
  border: none;
  padding-left: 32px;
}
::v-deep .el-table__row {
  height: 54px;
  //   border: none;
  //   padding-left: 32px;
}
.customer-table {
  margin: 0 auto;
  th {
    padding: 0 !important;
    height: 48px;
    line-height: 48px;
  }
  td {
    padding: 0 !important;
    height: 48px;
    line-height: 48px;
  }
}
.el-menu {
  background-color: initial;
}
.list-main {
  // width: 100%;
  width: 1070px;

  height: 100%;
  .exam-name {
    font-size: 14px;
    font-weight: 600;
    // font-family: PingFangSC, PingFangSC-Medium;
    text-align: left;
    color: #000000;
    line-height: 15px;
  }
  .handle-btn {
    width: 84px;
    cursor: pointer;
    height: 30px;
    border: 1px solid #979797;
    border-radius: 16px;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    &:hover {
      background: #1fa3ff;
      color: #fff;
      border: none;
    }
  }
  .main-header {
    padding-top: 40px;
    width: 989px;
    margin: 0 auto;
    // display: flex;
    margin-bottom: 18px;
    // justify-content: space-between;
    // align-items: center;
    .head-title {
      width: 100%;
      font-size: 20px;
      font-weight: 600;
      text-align: left;
      color: #000000;
      line-height: 28px;
      padding-bottom: 26px;
      //   margin-bottom: ;
    }
    .head-line {
      width: 100%;
      height: 1px;
      opacity: 0.1;
      background: #3e4294;
    }
    .head-modal {
      display: flex;
      align-items: center;
      padding-top: 28px;
      font-size: 16px;
      font-weight: 400;
      text-align: left;
      color: #666666;
      .label {
        margin-right: 20px;
      }
      .search-btn {
        width: 95px;
        height: 40px;
        background: #1fa3ff;
        border-radius: 10px;
        box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.02);
        line-height: 40px;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        cursor: pointer;
      }
      input {
        width: 190px;
        height: 40px;
        background: #f5f5f7;
        border-radius: 10px;
        outline: none;
        border: none;
        padding: 0 18px;
      }
    }
  }
  .main-content {
    // min-height: 275px;
    position: relative;
    height: 570px;
    // background: linear-gradient(
    //   136deg,
    //   rgba(255, 255, 255, 0.82),
    //   rgba(255, 255, 255, 0.8) 100%
    // );
    // border-radius: 15px;
    // box-shadow: 0px 32px 64px 0px rgba(0, 0, 0, 0.04);
    overflow: hidden;
  }
}
</style>
<style>
/* .main-content .el-table th.is-leaf, */
.main-content .el-table td,
.main-content .el-table--border,
.main-content .el-table__body-wrapper {
  /* grey */
  border: none;
  /* cursor: pointer; */
}
.main-content .el-table::before {
  height: 0;
}
</style>